module.exports = "/_next/static/images/0da73e0944641fe4e6d6733c427765c0-nubank-indoor-pool@xs-2x.jpg.webp";